// src/components/HorizontalTabs.tsx
import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface HorizontalTabsProps {
  tabs: string[]; // List of state names (e.g., "jaipur", "kota")
  activeTab: string | undefined; // Currently active state
  // onTabChange: (tab: string) => void; // Callback when a tab is clicked
  darkMode: any;
  setActiveTab: any;
  tabsTitleList: any;
}

const HorizontalTabs: React.FC<HorizontalTabsProps> = ({ tabs, activeTab, darkMode, setActiveTab, tabsTitleList }) => {
  // console.log(tabsTitleList, " tabsTitleList")
  // console.log(activeTab, " activeTab")
  const tabsContainerRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  // Scroll active tab into view when activeTab changes
  useEffect(() => {
    if (tabsContainerRef.current && activeTab) {
      const activeElement = tabsContainerRef.current.querySelector(`[data-tab-id="${activeTab}"]`) as HTMLElement;
      if (activeElement) {
        // Simple scroll into view
        activeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }, [activeTab, tabs]);

  const handleTabClick = (tabId: string) => {
    // onTabChange(tabId);
    setActiveTab(tabId)
    // Optionally, update URL param if you want the URL to reflect the active tab
    navigate(`/cat/${tabId}`, { replace: true });
  };

  const tabClasses = (tabId: string) => `
    px-4 py-2 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200
    ${darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-700 hover:text-gray-900'}
    ${activeTab === tabId
      ? (darkMode ? 'border-b-2 border-red-500 text-white' : 'border-b-2 border-red-600 text-gray-900')
      : (darkMode ? 'border-b-2 border-transparent hover:border-gray-600' : 'border-b-2 border-transparent hover:border-gray-300')
    }
  `;

  return (
    <div
      ref={tabsContainerRef}
      className={`flex overflow-x-auto no-scrollbar py-2 border-b ${darkMode ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-white'}`}
      style={{ WebkitOverflowScrolling: 'touch' }} // Smooth scrolling on iOS
    >
      {tabs.map((tab) => (
        <div
          key={tab}
          data-tab-id={tab} // Custom attribute to find the element
          className={tabClasses(tab)}
          onClick={() => handleTabClick(tab)}
        >
          {tabsTitleList[tab]}
           {/* Capitalize first letter */}
        </div>
      ))}
    </div>
  );
};

export default HorizontalTabs;